import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';
import { NavLink, NavLinkRenderProps } from 'react-router-dom';

import { SignOutLink } from '@/components/molecules/SignOutLink';
import { useTranslator } from '@/hooks/useTranslator';

interface Props {
  readonly label: string;
  readonly path: string;
  readonly icon: React.ReactElement;
}

export const MainMenuItem: React.FC<Props> = (props: Props): React.ReactElement => {
  const { label, icon, path } = props;

  const tr = useTranslator();

  if (path === 'sign-out') {
    return (
      <ListItem component={SignOutLink} to={path} disableGutters={true} disablePadding={true}>
        <Box sx={styles.container}>
          {icon}
          <Typography fontSize={16} lineHeight="24px" fontWeight={400} color="inherit">
            {tr(label)}
          </Typography>
        </Box>
      </ListItem>
    );
  } else {
    return (
      <ListItem disableGutters={true} disablePadding={true}>
        <NavLink to={path}>
          {(linkProps: NavLinkRenderProps): React.ReactNode => {
            const containerStyle: readonly SystemStyleObject[] = [
              styles.container,
              linkProps.isActive ? styles.active : null,
            ];

            return (
              <Box sx={containerStyle}>
                {icon}
                <Typography fontSize={16} lineHeight="24px" fontWeight={400} color="inherit">
                  {tr(label)}
                </Typography>
              </Box>
            );
          }}
        </NavLink>
      </ListItem>
    );
  }
};

const styles: Record<string, SystemStyleObject> = {
  container: {
    color: 'text.primary',
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    cursor: 'pointer',
    width: 204,
    px: '16px',
    height: 46,
    borderRadius: 4,
  },
  active: {
    color: 'primary.main',
    backgroundColor: 'custom.AlternativeBackground',
  },
};
